import React from 'react';
import { PERIOD_OPTIONS, Period } from '../../../api/adminDashboard';

interface PeriodSelectProps {
    value: Period;
    onChange: (period: Period) => void;
}

const PeriodSelect: React.FC<PeriodSelectProps> = ({ value, onChange }) => (
    <div className="ad-period-wrapper">
        <select
            className="ad-period-dropdown"
            value={value}
            aria-label="Reporting period"
            onChange={(event) => onChange(event.target.value as Period)}
        >
            {PERIOD_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
        <div className="ad-period-arrow">
            <svg width="10" height="6" viewBox="0 0 10 6" fill="none">
                <path
                    d="M1 1L5 5L9 1"
                    stroke="#64748B"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </div>
    </div>
);

export default PeriodSelect;
